import React, { useContext } from 'react';
import { AppContext } from '@prisjakt/ui-app-context';
import TextLink from '@prisjakt/ui-text-link';
import { TitleMediumText, H2Text } from '@prisjakt/ui/text/variants';
import * as S from './styles';
import { ExpertLandingPage } from '../../../../types';
import {
  InternalNavigationScope,
  trackInternalNavigationClick,
} from 'src/globals/tracking/tracking';

type Props = {
  data: ExpertLandingPage;
};

function ExpertSection({ data }: Props) {
  const { t, market, linkTo } = useContext(AppContext);

  if (!data?.items) return null;

  const { tests, toplists } = data.items;
  const { experts, expertCount } = data;

  const articleUrl = market.articles?.aboutExperts?.path;

  const content = [...tests, ...toplists];

  const expertsPage = linkTo('experts');

  const onCardClick = (onClickData: {
    id: string;
    title: string;
    type: string;
    url: string;
    index: number;
  }) => {
    trackInternalNavigationClick({
      scope: InternalNavigationScope.ARTICLE_CONTENT_CARD,
      nextPage: onClickData.url,
      index: onClickData.index,
    });
  };

  return (
    <S.ExpertSection>
      <S.Section>
        <S.Main>
          <div>
            <TitleMediumText>{t('expert', 'promo.advice')}</TitleMediumText>
            <H2Text>{t('expert', 'expert.brand-name')}</H2Text>
          </div>

          <S.Description>
            <div>{t('expert', 'entry.promo-text')} </div>

            <div>
              <TextLink
                to={articleUrl}
                onClick={() => {
                  if (articleUrl) {
                    trackInternalNavigationClick({
                      scope:
                        InternalNavigationScope.EXPERT_INDEPENDENT_GUARANTEE,
                      nextPage: articleUrl,
                    });
                  }
                }}
              >
                {t('expert', 'entry.link-to-article-text')}
              </TextLink>
            </div>
          </S.Description>

          <S.ButtonDesktop
            container="a"
            containerProps={{ href: expertsPage }}
            onClick={() =>
              trackInternalNavigationClick({
                scope: InternalNavigationScope.EXPERT_SHOW_ALL,
                nextPage: expertsPage,
              })
            }
          >
            {t('expert', 'entry.latest-link')}
          </S.ButtonDesktop>
        </S.Main>

        <S.ExpertList>
          <S.ListOfExperts
            experts={experts}
            count={expertCount || 0}
            limit={9}
            linkRest
          />
        </S.ExpertList>

        <S.ButtonMobile
          container="a"
          containerProps={{ href: expertsPage }}
          onClick={() =>
            trackInternalNavigationClick({
              scope: InternalNavigationScope.EXPERT_SHOW_ALL,
              nextPage: expertsPage,
            })
          }
        >
          {t('expert', 'entry.latest-link')}
        </S.ButtonMobile>
      </S.Section>

      <S.List>
        <TitleMediumText>{t('expert', 'entry.latest-title')}</TitleMediumText>
        <S.ContentList>
          <S.ContentCards items={content} limit={4} onClick={onCardClick} />
        </S.ContentList>
      </S.List>
    </S.ExpertSection>
  );
}

export default ExpertSection;
